import React from 'react';
import { Box, Typography, Grid, Container, Paper } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import SecurityIcon from '@mui/icons-material/Security';
import SpeedIcon from '@mui/icons-material/Speed';
import SupportIcon from '@mui/icons-material/Support';

const FeatureList = ({
  title = 'Our Features',
  description = 'Discover what makes our product special',
  features = [
    {
      icon: 'info',
      title: 'Feature 1',
      description: 'Description of feature 1'
    },
    {
      icon: 'security',
      title: 'Feature 2',
      description: 'Description of feature 2'
    },
    {
      icon: 'speed',
      title: 'Feature 3',
      description: 'Description of feature 3'
    },
    {
      icon: 'support',
      title: 'Feature 4',
      description: 'Description of feature 4'
    }
  ],
  columns = 2,
  backgroundColor = '#f5f5f5',
  textColor = '#333333',
  padding = '3rem 1rem'
}) => {
  console.log('Rendering FeatureList component with props:', { title, features });
  
  // Function to render the appropriate icon
  const renderIcon = (iconName) => {
    switch (iconName) {
      case 'info':
        return <InfoIcon fontSize="large" />;
      case 'security':
        return <SecurityIcon fontSize="large" />;
      case 'speed':
        return <SpeedIcon fontSize="large" />;
      case 'support':
        return <SupportIcon fontSize="large" />;
      default:
        return <InfoIcon fontSize="large" />;
    }
  };
  
  return (
    <Box
      sx={{
        backgroundColor,
        color: textColor,
        padding,
        width: '100%'
      }}
    >
      <Container maxWidth="lg">
        {title && (
          <Typography variant="h4" component="h2" align="center" gutterBottom>
            {title}
          </Typography>
        )}
        {description && (
          <Typography variant="subtitle1" align="center" sx={{ mb: 4 }}>
            {description}
          </Typography>
        )}
        <Grid container spacing={3}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={12 / columns} key={index}>
              <Paper 
                elevation={1}
                sx={{ 
                  p: 3, 
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                <Box sx={{ color: 'primary.main', mb: 2 }}>
                  {renderIcon(feature.icon)}
                </Box>
                <Typography variant="h6" gutterBottom>
                  {feature.title}
                </Typography>
                <Typography variant="body2">
                  {feature.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

// Define the fields for the Puck editor
FeatureList.fields = {
  title: {
    type: 'text',
    label: 'Title',
    default: 'Our Features'
  },
  description: {
    type: 'text',
    label: 'Description',
    default: 'Discover what makes our product special'
  },
  features: {
    type: 'array',
    label: 'Features',
    itemFields: {
      icon: {
        type: 'select',
        label: 'Icon',
        options: [
          { label: 'Info', value: 'info' },
          { label: 'Security', value: 'security' },
          { label: 'Speed', value: 'speed' },
          { label: 'Support', value: 'support' }
        ],
        default: 'info'
      },
      title: {
        type: 'text',
        label: 'Title',
        default: 'Feature Title'
      },
      description: {
        type: 'text',
        label: 'Description',
        default: 'Feature description goes here'
      }
    },
    default: [
      {
        icon: 'info',
        title: 'Feature 1',
        description: 'Description of feature 1'
      },
      {
        icon: 'security',
        title: 'Feature 2',
        description: 'Description of feature 2'
      },
      {
        icon: 'speed',
        title: 'Feature 3',
        description: 'Description of feature 3'
      },
      {
        icon: 'support',
        title: 'Feature 4',
        description: 'Description of feature 4'
      }
    ]
  },
  columns: {
    type: 'select',
    label: 'Columns',
    options: [
      { label: '1', value: 1 },
      { label: '2', value: 2 },
      { label: '3', value: 3 },
      { label: '4', value: 4 }
    ],
    default: 2
  },
  backgroundColor: {
    type: 'text',
    label: 'Background Color',
    default: '#f5f5f5'
  },
  textColor: {
    type: 'text',
    label: 'Text Color',
    default: '#333333'
  },
  padding: {
    type: 'text',
    label: 'Padding',
    default: '3rem 1rem'
  }
};

export default FeatureList; 